import {
  CODE_SCANNER_ICON,
  CODE_SCANNER_UI_CLASS_NAME,
  CodeScanner as CodeScannerComponent,
} from './CodeScanner';
import { withContainer } from './withContainer';

const CodeScanner = withContainer(CodeScannerComponent);

export {
  CODE_SCANNER_ICON,
  CODE_SCANNER_UI_CLASS_NAME,
  CodeScanner,
  CodeScannerComponent,
};
export * from './withContainer';
